import React, { useEffect, useRef } from "react";
import "../assets/css/ClinicallyProvenSection.css";
import BgVideo from "../assets/Video/0_People_Animation_1920x1010 (1).mp4";
import { useNavigate } from "react-router-dom";


const ClinicallyProvenSection = () => {
    const navigate = useNavigate();
    const fadeRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("show");
                        observer.unobserve(entry.target); // Animate once
                    }
                });
            },
            { threshold: 0.2 }
        );

        if (fadeRef.current) {
            observer.observe(fadeRef.current);
        }

        return () => {
            if (fadeRef.current) observer.unobserve(fadeRef.current);
        };
    }, []);

    return (
        <section className="video-section position-relative text-center text-white py-5">
            {/* Background Video */}
            <video className="bg-video" autoPlay muted loop playsInline>
                <source
                    src={BgVideo}
                    type="video/mp4"
                />
                Your browser does not support the video tag.
            </video>

            {/* Overlay */}
            <div className="overlay"></div>

            {/* Content */}
            <div className="container position-relative z-2 fade-content" ref={fadeRef}>
                <h2 className="fw-semibold mb-3 montserrat-font">
                    Clinically Proven <span className="fw-bold">Products</span>
                </h2>
                <p className="mb-4 poppins-font">
                    Skin and hair need the utmost care. Hence choosing an ideal product to
                    meet the needs must be gentle & backed by science. We are committed to
                    providing authentic solutions for your needs and are grateful for the
                    constant trust and praise from our adored clients.
                </p>

                <div className="package-btn">
                    <span className="line"></span>
                    <button className="all-packages-btn" onClick={() => navigate("/AllProducts")}>
                        All Packages <span className="arrow">→</span>
                    </button>
                    <span className="line"></span>
                </div>
            </div>
        </section>
    );
};

export default ClinicallyProvenSection;
